import PropTypes from 'prop-types';
import React, {
  useState, useImperativeHandle, forwardRef, memo, useMemo,
} from 'react';

import { Map } from 'immutable';

import Typography from '@mui/material/Typography';

const SIZELIMIT = 20;

function VideoTimer({ stopCallback = null, max, min, setStoppable }, ref) {
  let timerIntervalID;

  const [state, setState] = useState(new Map());

  const TIMELIMIT = useMemo(() => {
    return max || 60;
  }, [max]);

  const TIMEMIN = useMemo(() => {
    return min || 0;
  }, [min]);

  const time = state.get('time', '0:00');
  const size = state.get('size', '0mb');

  useImperativeHandle(ref, () => ({
    start(blobs) {
      let timer = 1;

      timerIntervalID = setInterval(() => {
        const minutes = parseInt(timer / 60, 10);
        let seconds   = parseInt(timer % 60, 10);

        seconds = seconds < 10 ? `0${seconds}` : seconds;

        // Converting blob size in Bytes to MB
        const blob     = new Blob(blobs, { type: 'video/webm' });
        const blobSize = (blob.size * 0.000001).toFixed(2) * 1;

        setState(state
          .set('time', `${minutes}:${seconds}`)
          .set('size', `${blobSize}mb`));

        timer += 1;

        if (timer < TIMEMIN) {
          setStoppable(false);
        } else {
          setStoppable(true);
        }

        if (timer > TIMELIMIT || blobSize >= SIZELIMIT) {
          stopCallback();
        }
      }, 1000);
    },
    stop() {
      clearInterval(timerIntervalID);
    },
  }), []);

  return (
    <>
      <Typography variant="p" sx={{ fontStyle: 'italic', mt: 2, textAlign: 'center' }}>
        {t('eos.landing_page.text.video_limit')}
      </Typography>
      <Typography variant="p" sx={{ mt: 2 }}>
        {time}
      </Typography>
      <Typography variant="p" sx={{ mt: 1 }}>
        {t('eos.landing_page.text.size_of_mb', { size })}
      </Typography>
    </>
  );
}

const TimerMemoRef = memo(forwardRef(VideoTimer));

VideoTimer.propTypes = {
  stopCallback: PropTypes.func,
};

export default TimerMemoRef;
